module.exports = ".sk-spinner-three-bounce div{background-color:#ffffff;height:13px;width:13px}\n"